module.exports = __webpack_public_path__ + "img/kilmarnock-logo-png-transparent.d70bb43e.png";